// extracted by mini-css-extract-plugin
export default {"paginator":"SearchPaginator_paginator__qvuG0"};